import { VARIATION_TYPES } from 'Pods/ThreeDStudio/constants'
import { VIEWER_SIDEBAR_TAB } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Whether a provider model id belongs to the animate flow. Derived from
 * VARIATION_TYPES so the viewer's player and the variation card's chip can
 * never disagree about which runs count as animations.
 *
 * @param {string|undefined} providerModelId - openedModel.providerModelId
 * @returns {boolean}
 */
export const isAnimationModel = providerModelId => (
  VARIATION_TYPES[providerModelId]?.tab === VIEWER_SIDEBAR_TAB.ANIMATE
)
